import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../config/axiosConfig';

export const fetchAllFinancial = createAsyncThunk(
  'editableFinance/fetchAll',
  async () => {
    const response = await axiosInstance.get('/financial/getfinancial');
    return response.data;
    
  }
);

export const fetchFinancialByQuotationId = createAsyncThunk(
  'editableFinance/fetchByQuotationId',
  async (quotationId, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/financial/getfinancial/${quotationId}`);
      if (!response.data || Object.keys(response.data).length === 0) {
        return null;
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch financial data');
    }
  }
);


export const upsertFinancialData = createAsyncThunk('editableFinance/upsert', async (data) => {
    const response = await axiosInstance.put('/financial/financial', data);
    return response.data;
  }
);

export const deleteFinancialData = createAsyncThunk(
  'editableFinance/delete',
  async (id) => {
    const response = await axiosInstance.delete(`/financial/deletefinancial/${id}`);
    return { id, ...response.data };
  }
);

const editableFinanceSlice = createSlice({
  name: 'EditableFinance',
  initialState: {
    allData: [],
    selectedProjectData: null,
    status: 'idle',
    error: null,
  },
  reducers: {
    clearProjectData: (state) => {
      state.selectedProjectData = null;
    },
  },
  extraReducers: (builder) => {
    builder

    .addCase(fetchAllFinancial.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchAllFinancial.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.allData = action.payload;
      })
      .addCase(fetchAllFinancial.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })

      .addCase(fetchFinancialByQuotationId.pending, (state) => {
        state.status = 'loading';
        state.selectedProjectData = null; // ✅ Clear old data immediately
      })
      .addCase(fetchFinancialByQuotationId.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.selectedProjectData = action.payload;
      })
      .addCase(fetchFinancialByQuotationId.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
        state.selectedProjectData = null; // ✅ Clear old data on error too
      })

      .addCase(upsertFinancialData.fulfilled, (state, action) => {
        const updated = action.payload.data;
        const index = state.allData.findIndex(item => item.quotationId === updated.quotationId || item.ProjectName === updated.ProjectName);
        if (index >= 0) {
          state.allData[index] = updated;
        } else {
          state.allData.push(updated);
        }
      })

      .addCase(deleteFinancialData.fulfilled, (state, action) => {
        const deletedId = action.payload.id;
        state.allData = state.allData.filter(item => item._id !== deletedId);
      });
  },
});

export const { clearProjectData } = editableFinanceSlice.actions;
export default editableFinanceSlice.reducer;
